type LogArgs = any[];

const isLocal = typeof window !== "undefined" && /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);
const isDev = import.meta.env.DEV;

interface LogContext {
  component?: string;
  action?: string;
  userId?: string;
  [key: string]: any;
}

export const logger = {
  // Development-only debug logging
  debug: (...args: LogArgs) => {
    if (isDev) console.debug("[debug]", ...args);
  },
  
  // Development-only info logging
  info: (...args: LogArgs) => {
    if (isDev) console.info("[info]", ...args);
  },
  
  // Production warnings (always shown)
  warn: (...args: LogArgs) => console.warn("[warn]", ...args),
  
  // Production errors (always shown)
  error: (...args: LogArgs) => console.error("[error]", ...args),
  
  // Structured development logging with context
  devLog: (message: string, context?: LogContext) => {
    if (isDev) {
      console.log(`[dev] ${message}`, context || '');
    }
  },
  
  // Performance logging (development only)
  perf: (label: string, fn: () => void) => {
    if (isDev) {
      const start = performance.now();
      fn();
      const end = performance.now();
      console.log(`[perf] ${label}: ${(end - start).toFixed(2)}ms`);
    } else {
      fn();
    }
  },
  
  // Conditional development logging
  devOnly: (...args: LogArgs) => {
    if (isDev) console.log("[dev-only]", ...args);
  },
  
  // Component lifecycle logging
  lifecycle: (component: string, action: string, data?: any) => {
    if (isDev) {
      console.log(`[lifecycle] ${component} - ${action}`, data || '');
    }
  }
};
